import Phaser from "phaser";
import { defenseMultiplayer } from "../systems/multiplayer-client";
import { sideForSlot, type MultiplayerBattleContext } from "../systems/multiplayer-rules";

/**
 * Multiplayer uses the production single-player battlefield. This scene is only
 * a bridge that resolves the authenticated player's slot and launches Game.
 */
export class CoopBattleScene extends Phaser.Scene {
  constructor() {
    super("CoopBattle");
  }

  create(): void {
    const match = defenseMultiplayer.matchSnapshot;
    const lobby = defenseMultiplayer.lobbyState;
    const localPlayerId = defenseMultiplayer.playerId;
    if (!match || !localPlayerId) {
      this.scene.start("MultiplayerLobby");
      return;
    }
    const players = lobby?.players ?? [];
    const localSlot = Math.max(
      0,
      players.findIndex((player) => player.playerId === localPlayerId),
    );
    const context: MultiplayerBattleContext = {
      mode: match.mode,
      localPlayerId,
      localSide: sideForSlot(localSlot),
      playerIds: players.map((player) => player.playerId),
      isHost: lobby?.hostPlayerId === localPlayerId,
    };
    this.registry.set("multiplayer-battle-context", context);
    this.registry.set("selected-scenario-id", lobby?.scenarioId ?? "castle-approach-1");
    this.scene.start("Game");
  }
}
